export function checkStringToNumber(val:string|number):number{
    return typeof val === "string" ? +val : val;
}

export function checkNumberToString(val:string|number):string{
    return typeof val === "number" ? val.toString() : val;
}